import React from "react";
import {
  capitalize,
  capitalizeEachWord,
  formatDate,
} from "../../../Common/CommonFunction";
import { educationLevelsOptions, schoolMediumsOptions, performanceScaleOptions } from "../../../../Constant";
import github from "../../../../assets/images/resumeIcons/github.png";
import linkedin from "../../../../assets/images/resumeIcons/linkedin.png";
import facebook from "../../../../assets/images/resumeIcons/facebook.png";
import twitter from "../../../../assets/images/resumeIcons/twitter.png";
import stackoverflow from "../../../../assets/images/resumeIcons/stackoverflow.png";
import email from "../../../../assets/images/resumeIcons/email.png";
import call from "../../../../assets/images/resumeIcons/call.png";
import location from "../../../../assets/images/resumeIcons/location.png";
import star_blank from "../../../../assets/images/star/star_blank.png"
import star_half from "../../../../assets/images/star/star_half.png"
import star from "../../../../assets/images/star/star.png"
const Template2 = ({ jobseekerData = {} }) => {
  const renderSocialIcon = (socialProfileName) => {
    switch (socialProfileName.toUpperCase()) {
      case "LINKEDIN":
        return <img className="me-2" src={linkedin} alt="LinkedIn Icon" />;
      case "GITHUB":
        return <img className="me-2" src={github} alt="GitHub Icon" />;
      case "FACEBOOK":
        return <img className="me-2" src={facebook} alt="Facebook Icon" />;
      case "TWITTER":
        return <img className="me-2" src={twitter} alt="Twitter Icon" />;
      case "STACKOVERFLOW":
        return <img className="me-2" src={stackoverflow} alt="StackOverflow Icon" />;
      default:
        return null;
    }
  };

  const {
    country_code1 = "",
    jobseeker_phone1 = "",
    jobseeker_email1 = "",
    jobseeker_full_name = "",
    jobseeker_preferred_job_title = "",
    resume_headline = "",
    work_experience = [],
    education = [],
    it_skills = [],
    work_sample = [],
    online_detail_result = [],
    jobseeker_location = {},
    primary_skill = []
  } = jobseekerData;

  return (
    <div id="resume2">
      <main className="resume2">
        <header>
          <a href="#" target="_blank"><img

            src="/job/naukrify_poweredby.png"
            // src="https://dev.naukrify.com/job/naukrify_poweredby.png"
            alt="User profile picture"
            className="img-fluid"
          /></a>
        </header>
        <div className="resume-container">

          <div className="user-name">
            <h1>{jobseeker_full_name && jobseeker_full_name}</h1>
            <p>{jobseeker_preferred_job_title && jobseeker_preferred_job_title}</p>
          </div>

          <div className="content">
            <aside className="left-section">
              {resume_headline && (
                <section className="profile">
                  <h3>PROFILE</h3>
                  <p>{resume_headline}</p>
                </section>
              )}

              {(jobseeker_email1 || jobseeker_phone1 || online_detail_result.length > 0) && (
                <section className="contact">
                  <h3>CONTACT</h3>
                  <table>
                    <tbody>
                      {jobseeker_email1 && (
                        <tr>
                          <td>
                            <img src={email} alt="Email Icon" />
                          </td>
                          <td>
                            <a href={`mailto:${jobseeker_email1}`}>{jobseeker_email1}</a>
                          </td>
                        </tr>
                      )}
                      {jobseeker_phone1 && (
                        <tr>
                          <td>
                            <img src={call} alt="Phone Icon" />
                          </td>
                          <td>
                            <a href={`tel:${country_code1}${jobseeker_phone1}`}>
                              {country_code1}{jobseeker_phone1}
                            </a>
                          </td>
                        </tr>
                      )}
                      {jobseeker_location.label && (
                        <tr>
                          <td>
                            <img src={location} alt="Location Icon" />
                          </td>
                          <td>
                            <span>{`${jobseeker_location.label}`}</span>
                          </td>
                        </tr>
                      )}
                      {online_detail_result.map((profile, index) => (
                        (profile.social_profile_name.toUpperCase() === "LINKEDIN" ||
                          profile.social_profile_name.toUpperCase() === "GITHUB") && (
                          <tr key={index}>
                            <td>
                              {renderSocialIcon(profile.social_profile_name)}
                            </td>
                            <td>
                              <a href={profile.url} target="_blank" rel="noopener noreferrer">
                                {profile.url}
                              </a>
                            </td>
                          </tr>
                        )
                      ))}
                    </tbody>
                  </table>

                </section>
              )}

              {education.length > 0 && (
                <section className="education">
                  <h3>EDUCATION</h3>
                  <div className="list-container mt-15">
                    {education.map((edu, index) => (
                      <div key={index} className="job">
                        {edu.education_level != "SECONDARY" &&
                          edu.education_level != "SENIOR_SECONDARY" ? (
                          <div>
                            <p> <strong>
                              {edu.jobseeker_degree &&
                                edu.jobseeker_degree.label}{" "}
                              - {edu.jobseeker_specialization} - {" "}
                              {edu.passing_year}
                            </strong>  </p>
                            <p>{edu.board}</p>
                            <p>{
                              performanceScaleOptions.find(
                                (option) =>
                                  option.value == edu.performance_scale
                              )?.label
                            }{" "}
                              : {edu.performance}</p>
                          </div>
                        ) : (
                          <div>
                            <p> <strong>
                              {
                                educationLevelsOptions.find(
                                  (option) =>
                                    option.value == edu.education_level
                                )?.label
                              }{" "}
                              - {edu.passing_year}{" "}
                            </strong> </p>
                            <p>{edu.board} -{" "}
                              {
                                schoolMediumsOptions.find(
                                  (option) => option.value == edu.school_medium
                                )?.label
                              }
                            </p>
                            <p>{
                              performanceScaleOptions.find(
                                (option) =>
                                  option.value == edu.performance_scale
                              )?.label
                            }{" "}
                              : {edu.performance}</p>
                          </div>
                        )}

                      </div>
                    ))}
                  </div>
                </section>
              )}

              {it_skills.length > 0 && (
                <section className="skills">
                  <h3>SKILLS</h3>
                  <ul>
                    {it_skills.slice(0, 15).map((s, index) => (
                      <li key={index}>{s.it_skill.label}</li>
                    ))}
                  </ul>
                </section>
              )}
            </aside>

            {/* Right Section */}
            <section className="right-section">
              {work_experience.length > 0 && (
                <section className="work-experience">
                  <h3>WORK EXPERIENCE</h3>
                  {work_experience.map((job, index) => (
                    <div className="job" key={index}>
                      <p className="job-role"><strong>{`${capitalizeEachWord(job.designation)} @ ${capitalizeEachWord(job.organization.label)}`}</strong></p>
                      <p>{`${formatDate(job.started_working_from)} - ${formatDate(job.worked_till)}`}</p>
                      <p>{job.job_description}</p>
                    </div>
                  ))}
                </section>
              )}

              {work_sample.length > 0 && (
                <section className="work-samples">
                  <h3>WORK SAMPLES</h3>
                  {work_sample.map((work, index) => (
                    <div className="job" key={index}>
                      <p className="job-role"><strong>{`${capitalizeEachWord(work.work_title)} (${formatDate(work.work_start)} - ${formatDate(work.work_end)})`}</strong></p>
                      <p>
                        <a href={work.work_url}>{work.work_url}</a>
                      </p>
                      <p>{capitalize(work.work_description)}</p>
                    </div>
                  ))}
                </section>
              )}

              {/* {primary_skill.length > 0 && (
              <section className="main-skills">
                <h3>MAIN SKILLS</h3>
                <div className="skills-list">
                  {primary_skill.slice(0, 6).map((skill, index) => (
                    <div className="skill" key={index}>
                      <label>{skill.label}</label>
                      <div className="progress-bar">
                        <div className="progress" style={{ width: `${skill.skill_rating * 10}%` }}></div>
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            )} */}

              {primary_skill.length > 0 && (
                <section className="main-skills">
                  <h3>MAIN SKILLS</h3>
                  <div className="star-skill-list">
                    {primary_skill.map((skill, index) => (
                      <div className="star-skill" key={index}>
                        <p>{skill.label}</p>
                        <div className="star-container">
                          {[...Array(5)].map((_, i) => {
                            let starImage;
                            if (i < Math.floor(skill.skill_rating / 2)) {
                              starImage = star; // Full star
                            } else if (i < Math.ceil(skill.skill_rating / 2)) {
                              starImage = star_half; // Half star
                            } else {
                              starImage = star_blank; // Empty star
                            }
                            return (
                              <img
                                key={i}
                                className="image"
                                src={starImage}
                                alt="star"

                              />
                            );
                          })}
                        </div>
                      </div>
                    ))}
                  </div>
                </section>
              )}
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Template2;